// MUNYA OS · #489 · el puente entre el botón de wb.munya.studio y el formulario de aquí.
//
// El botón del sitio abre os.munya.studio/?sugerencia-web=<url de la página>. Si quien
// pulsa no tiene sesión abierta, el login de Microsoft vuelve SIEMPRE a «/» y por el
// camino se perdería el parámetro; por eso lo primero que hace la app al arrancar es
// guardarlo aquí —antes de que React decida si pinta el formulario o la pantalla de
// login— y limpiar la barra de direcciones. Al volver del login sigue estando.

const PARAM = 'sugerencia-web';
const LLAVE = 'munya:sugerencia-web';
// Un login con MFA de por medio puede irse a varios minutos; dos horas cubre de sobra
// sin que una intención de anteayer reabra el formulario sola.
const CADUCA_MS = 2 * 60 * 60 * 1000;

// La misma puerta que la API: solo direcciones del sitio. Un enlace manipulado no puede
// dejar puesta como «página» una dirección ajena que luego alguien abriría desde el panel.
const ORIGENES = ['https://wb.munya.studio', 'http://localhost:3100'];

function esDelSitio(url: string): boolean {
  try {
    return ORIGENES.includes(new URL(url).origin);
  } catch {
    return false;
  }
}

interface Guardada {
  url: string;
  ts: number;
}

/** Se llama UNA vez al arrancar la app, antes de montar React. */
export function capturarSugerenciaWeb(): void {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  const url = params.get(PARAM);
  if (!url) return;

  if (esDelSitio(url)) {
    try {
      const dato: Guardada = { url, ts: Date.now() };
      window.localStorage.setItem(LLAVE, JSON.stringify(dato));
    } catch {
      /* almacenamiento lleno o bloqueado · se pierde la intención, no la sesión */
    }
  }

  // La barra de direcciones queda limpia: recargar no vuelve a abrir el formulario.
  params.delete(PARAM);
  const query = params.toString();
  window.history.replaceState(
    null,
    '',
    window.location.pathname + (query ? `?${query}` : '') + window.location.hash,
  );
}

/** URL pendiente de comentar, si la hay y no ha caducado. */
export function leerSugerenciaWeb(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const crudo = window.localStorage.getItem(LLAVE);
    if (!crudo) return null;
    const dato = JSON.parse(crudo) as Guardada;
    if (!dato.url || !esDelSitio(dato.url) || Date.now() - dato.ts > CADUCA_MS) {
      window.localStorage.removeItem(LLAVE);
      return null;
    }
    return dato.url;
  } catch {
    return null;
  }
}

/** Al enviar o al cerrar: la intención ya se ha atendido. */
export function olvidarSugerenciaWeb(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(LLAVE);
  } catch {
    /* nada que limpiar */
  }
}
